import * as http from './http';

import { Dict } from '../../models';
import ApiService from './service';
import { stringify } from 'query-string';
import { ApiResponse, ListSort, PaginatedApiResponse } from '..';
import {
  ExternalCrmDataField,
  CustomMappingWithForm,
  DefaultMapping,
  TiktokPage,
  TiktokLeadCampaign,
  TiktokCampaign,
  TiktokAds,
  TiktokAdForm,
  CreateTiktokLeadCampaign,
  TiktokAdgroup,
} from '../models/tiktok';

export class TiktokService extends ApiService {
  public async createTiktokPage(data: TiktokPage) {
    const url = `${this.apiDomain}/api/external-leads/tiktok/page`;

    const response = await http.post<ApiResponse<TiktokPage>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }
  public async updateTiktokPage(data: TiktokPage, id: string) {
    const url = `${this.apiDomain}/api/external-leads/tiktok/page/${id}`;

    const response = await http.put<ApiResponse<TiktokPage>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }
  public async loadAllTiktokLeadCampaign(
    data: {
      page: number;
      search?: string;
      perPage: number;
    } & ListSort &
      Dict
  ): Promise<
    PaginatedApiResponse<TiktokLeadCampaign> & { lastUpdatedAt: Date }
  > {
    const url = `${this.apiDomain}/api/external-leads/tiktok/lead-campaign?query=${data.query}&page=${data.page}&perPage=${data.perPage}`;

    const resposne = await http.get<
      PaginatedApiResponse<TiktokLeadCampaign> & { lastUpdatedAt: Date }
    >(url, this.store);
    return { ...resposne?.data, lastUpdatedAt: new Date() };
  }

  public async getPages(): Promise<TiktokPage[]> {
    const url = `${this.apiDomain}/api/external-leads/tiktok/page`;
    const response = await http.get<ApiResponse<TiktokPage[]>>(url, this.store);
    return response?.data?.data;
  }

  public async getCampaigns(): Promise<TiktokCampaign[]> {
    const url = `${this.apiDomain}/api/external-leads/tiktok/campaign`;
    const response = await http.get<ApiResponse<TiktokCampaign[]>>(
      url,
      this.store
    );
    return response?.data?.data;
  }

  public async getAdgroups(): Promise<TiktokAdgroup[]> {
    const url = `${this.apiDomain}/api/external-leads/tiktok/adgroup`;
    const response = await http.get<ApiResponse<TiktokAdgroup[]>>(
      url,
      this.store
    );
    return response?.data?.data;
  }

  public async getAds(): Promise<TiktokAds[]> {
    const url = `${this.apiDomain}/api/external-leads/tiktok/ad`;
    const response = await http.get<ApiResponse<TiktokAds[]>>(url, this.store);
    return response?.data?.data;
  }

  public async getForms(pageId: string): Promise<TiktokAdForm[]> {
    const url = `${this.apiDomain}/api/external-leads/tiktok/ad-form/${pageId}`;
    const response = await http.get<ApiResponse<TiktokAdForm[]>>(
      url,
      this.store
    );
    return response?.data?.data;
  }

  public async createTiktokCampaign(data: TiktokCampaign) {
    const url = `${this.apiDomain}/api/external-leads/tiktok/campaign`;

    const response = await http.post<ApiResponse<TiktokCampaign>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }

  public async updateTiktokCampaign(data: TiktokCampaign) {
    const url = `${this.apiDomain}/api/external-leads/tiktok/campaign/${data._id}`;

    const response = await http.put<ApiResponse<TiktokCampaign>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }
  public async updateTiktokAdgroup(data: TiktokAdgroup) {
    const url = `${this.apiDomain}/api/external-leads/tiktok/adgroup/${data._id}`;

    const response = await http.put<ApiResponse<TiktokAdgroup>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }
  public async updateTiktokAds(data: TiktokAds) {
    const url = `${this.apiDomain}/api/external-leads/tiktok/ad/${data._id}`;

    const response = await http.put<ApiResponse<TiktokAds>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async updateTiktokForms(data: TiktokAdForm) {
    const url = `${this.apiDomain}/api/external-leads/tiktok/ad-form/${data._id}`;

    const response = await http.put<ApiResponse<TiktokAdForm>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async createTiktokAdgroup(data: TiktokAdgroup) {
    const url = `${this.apiDomain}/api/external-leads/tiktok/adgroup`;

    const response = await http.post<ApiResponse<TiktokAdgroup>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }

  public async createTiktokAd(data: TiktokAds) {
    const url = `${this.apiDomain}/api/external-leads/tiktok/ad`;

    const response = await http.post<ApiResponse<TiktokAds>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }

  public async createTiktokLeadCampaign(data: CreateTiktokLeadCampaign) {
    const url = `${this.apiDomain}/api/external-leads/tiktok/lead-campaign`;

    const response = await http.post<ApiResponse<TiktokAds>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }

  public async updateTiktokLeadCampaign(
    data: CreateTiktokLeadCampaign,
    id: string
  ) {
    const url = `${this.apiDomain}/api/external-leads/tiktok/update/lead-campaign/${id}`;

    const response = await http.post<ApiResponse<TiktokAds>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async deleteTiktokLeadCampaign(id?: string) {
    const url = `${this.apiDomain}/api/external-leads/tiktok/delete/lead-campaign/${id}`;

    const response = await http.remove<ApiResponse<TiktokAds>>(url, this.store);

    return response?.data;
  }

  public async getPageDetails(pageId: string): Promise<TiktokPage> {
    const url = `${this.apiDomain}/api/external-leads/tiktok/page/${pageId}`;
    const response = await http.get<ApiResponse<TiktokPage>>(url, this.store);
    return response?.data?.data;
  }

  public async getTiktokLeadCampaignDetails(
    id: string
  ): Promise<TiktokLeadCampaign> {
    const url = `${this.apiDomain}/api/external-leads/tiktok/lead-campaign/${id}`;
    const response = await http.get<ApiResponse<TiktokLeadCampaign>>(
      url,
      this.store
    );
    return response?.data?.data;
  }

  public async getLeadExternalDataFields() {
    const url = `${this.apiDomain}/api/lead/external-data-fields`;

    const resposne = await http.get<ApiResponse<ExternalCrmDataField[]>>(
      url,
      this.store
    );
    return resposne?.data.data;
  }
  public async createOrUpdateTiktokFormFields(data: CustomMappingWithForm) {
    const url = `${this.apiDomain}/api/external-leads/tiktok/form-field`;

    const response = await http.post(url, data, this.store);

    return response?.data?.data;
  }
  public async getTiktokAdForms() {
    const url = `${this.apiDomain}/api/external-leads/tiktok/ad-form`;

    const resposne = await http.get<ApiResponse<TiktokAdForm[]>>(
      url,
      this.store
    );
    return resposne?.data.data;
  }
  public async createTiktokAdForm(data: TiktokAdForm) {
    const url = `${this.apiDomain}/api/external-leads/tiktok/ad-form`;

    const response = await http.post<ApiResponse<TiktokAdForm>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }
  public async getTiktokFormFields(formId?: string) {
    const url = `${
      this.apiDomain
    }/api/external-leads/tiktok/form-field?${stringify({ formId })}`;
    const resposne = await http.get<ApiResponse<DefaultMapping[]>>(
      url,
      this.store
    );
    return resposne?.data.data;
  }
  public async getDefaultTiktokFormFields() {
    const url = `${this.apiDomain}/api/external-leads/tiktok/default-form-field`;

    const resposne = await http.get<
      ApiResponse<{ name: string; value: string }[]>
    >(url, this.store);
    return resposne?.data.data;
  }
}
